import { useEffect } from 'react';

import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';
import { useDialogOpenedContext } from '@sorare/core/src/contexts/dialogOpened';
import { useSnackNotificationContext } from '@sorare/core/src/contexts/snackNotification';
import { useIsMobileApp } from '@sorare/core/src/hooks/useIsMobileApp';

export const usePackOpeningInterruptedSnackbar = () => {
  const { currentUser } = useCurrentUserContext();
  const { isIosApp } = useIsMobileApp();

  const { showNotification } = useSnackNotificationContext();

  const { isDialogOpen } = useDialogOpenedContext();

  const shouldShowToast =
    !isIosApp && currentUser?.claimablePacks.length && !isDialogOpen;

  useEffect(() => {
    if (!shouldShowToast) {
      return;
    }
    if (currentUser?.claimablePacks.length) {
      showNotification('packOpeningInterruptedCardsPending');
    }
  }, [currentUser?.claimablePacks, shouldShowToast, showNotification]);

  return null;
};
